// @ts-strict-ignore
/**
 * CheckboxCellComponent
 */
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Injector,
  OnDestroy,
} from '@angular/core';

import { BaseComponent } from '@app/components/base-component/base.component';

import type { ICellRendererParams, RowSelectedEvent } from 'ag-grid-community';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['checkbox-cell.component.scss'],
  template: ` <div>
    @if (isAutoApplied) {
      <div class="auto-applied">
        {{ Strings.Loyalty.AutoApplied | translate }}
      </div>
    } @else {
      <input
        class="x_checkbox x_md"
        type="checkbox"
        [disabled]="isDisabled"
        [checked]="isSelectedRow"
      />
    }
  </div>`,
  standalone: false,
})
export class CheckboxCellComponent extends BaseComponent implements OnDestroy {
  public isSelectedRow = false;
  public isDisabled = false;
  public isAutoApplied = false;

  private rowSelectedListener?: (event: RowSelectedEvent) => void;
  private node?: any;

  public constructor(
    private changeDetector: ChangeDetectorRef,
    protected injector: Injector,
  ) {
    super(injector);
  }

  public agInit(params: ICellRendererParams): void {
    this.isSelectedRow = params.node?.isSelected();
    this.isAutoApplied = params.node.data?.isAutoApplied;
    this.isDisabled = !params.node.selectable;

    this.node = params.node;

    this.rowSelectedListener = (event: RowSelectedEvent) => {
      this.isSelectedRow = event.node.isSelected();
      this.changeDetector.markForCheck();
    };
    params.node.addEventListener('rowSelected', this.rowSelectedListener);
  }

  public ngOnDestroy(): void {
    if (this.node && this.rowSelectedListener) {
      this.node.removeEventListener('rowSelected', this.rowSelectedListener);
    }
  }
}
